export default __webpack_public_path__ + "static/help_02_02_1-90ce97d9fab58962f1cdd6002b4f3239.png";